// src/components/headerone/bots/AWSBot.js
// AWS Lex bot component - bot is loaded via DynamicBotLoader
// This component just ensures the bot has access to user data
import React from 'react';
import DynamicBotLoader from '../../DynamicBotLoader/Main.js';

function AWSBot({ userData, payload }) {
  // AWS Lex bot is loaded via DynamicBotLoader
  // ConnectAttributes are already set in SharedHeader
  // The bot will use the attributes from sessionStorage set by ConnectAttributes
  return <DynamicBotLoader />;
}

export default AWSBot;





